// extracted by mini-css-extract-plugin
export default {"highlight":"nZAQRtEYkZMNM0vOyx9a"};